import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token =
    localStorage.getItem("token") || localStorage.getItem("adminToken");

  console.log("PROTECTED ROUTE TOKEN:", token);

  if (!token || token === "undefined" || token === "null") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}